import { useState } from 'react'
import { PropertyEndpoint } from '../../../api';
import { Upload, Image, message } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const styles = {
    tabs: {
        marginBottom: "20px"
    },
    tabList: {
        display: "flex",
        gap: "10px",
        listStyle: "none",
        padding: 0,
        margin: 0
    },
    tabItem: {},
    tabButton: {
        padding: "10px 22px",
        borderRadius: "30px",
        border: "1px solid #d0d7de",
        backgroundColor: "#ffffff",
        cursor: "pointer",
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.25s ease",
        color: "#4a4a4a",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    },
    activeTab: {
        backgroundColor: "#0d6efd",
        color: "white",
        borderColor: "#0d6efd",
        boxShadow: "0 3px 6px rgba(0, 98, 255, 0.25)",
        fontWeight: "600"
    }
};


function AddProperty() {
    const [selectedType, setSelectedType] = useState('apartement')
    const [formData, setFormData] = useState({
        // Common property_data fields
        name: '',
        province: '',
        city: '',
        full_address: '',
        surface_area: '',
        building_area: '',
        general_facilities: '',
        private_facilities: '',
        photo: null,
        property_type: 'apartement',
        rent_type: 'monthly',
        is_furnished: 'unfurnished',
        min_rent: '',
        rent_price: '',
        deposit: '',
        // Detail data fields (dynamic based on type)
        // Apartement
        tower_name: '',
        floor_number: '',
        unit_number: '',
        bedrooms: '',
        bathrooms: '',
        ipl: '',
        // Boarding
        has_private_bathroom: false,
        max_occupants: '',
        facilities: '',
        // House
        floors: '',
        garage: false,
        // Commercial
        electricity_capacity: '',
        parking_capacity: ''
    })
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [uploadList, setUploadList] = useState([]);
    const propertyTypes = ['apartement', 'boarding', 'house', 'commercial']
    const rentTypes = ['daily', 'monthly', 'yearly']
    const furnishedTypes = ['unfurnished', 'semi-furnished', 'furnished']
    const propertyApi = new PropertyEndpoint()

    // Function to clean input from letters for numeric fields
    const cleanNumericInput = (value) => {
        // Remove all non-numeric characters except decimal point
        return value.replace(/[^0-9.]/g, '');
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === 'file') {
            setFormData(prev => ({
                ...prev,
                [name]: prev[name]
                    ? [...prev[name], ...Array.from(files)] // append file baru
                    : Array.from(files)
            }));
        } else {
            // Clean numeric inputs from letters
            const numericFields = [
                'floor_number', 'bedrooms', 'bathrooms', 'ipl', 'max_occupants',
                'floors', 'parking_capacity', 'surface_area', 'building_area',
                'min_rent', 'rent_price', 'deposit'
            ];

            const cleanValue = numericFields.includes(name) ? cleanNumericInput(value) : value;

            setFormData(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : cleanValue
            }));
        }
    };

    const handleTypeChange = (newType) => {
        setSelectedType(newType)
        setFormData(prev => ({
            ...prev,
            property_type: newType
        }))
    }

    const handleRemovePhoto = (fileToRemove) => {
        setFormData(prev => ({
            ...prev,
            photos: prev.photos.filter(f => f !== fileToRemove),
        }));

        setUploadList(prev => prev.filter(f => f !== fileToRemove));
    };



    const createFormData = () => {
        const submitData = new FormData()

        // Common property_data
        submitData.append('type', formData.property_type)
        submitData.append('property_data[name]', formData.name)
        submitData.append('property_data[province]', formData.province)
        submitData.append('property_data[city]', formData.city)
        submitData.append('property_data[full_address]', formData.full_address)
        submitData.append('property_data[general_facilities]', formData.general_facilities)
        submitData.append('property_data[private_facilities]', formData.private_facilities)
        submitData.append('property_data[surface_area]', formData.surface_area)
        submitData.append('property_data[building_area]', formData.building_area)
        if (formData.photos && formData.photos.length > 0) {
            formData.photos.forEach((file, index) => {
                submitData.append(`property_data[photos][]`, file)
            })
        }
        submitData.append('property_data[property_type]', formData.property_type)
        submitData.append('property_data[rent_type]', formData.rent_type)
        submitData.append('property_data[is_furnished]', formData.is_furnished)
        submitData.append('property_data[min_rent]', formData.min_rent)
        submitData.append('property_data[rent_price]', formData.rent_price)
        submitData.append('property_data[deposit]', formData.deposit)

        // Dynamic detail_data based on property type
        switch (selectedType) {
            case 'apartement':
                submitData.append('detail_data[tower_name]', formData.tower_name)
                submitData.append('detail_data[floor_number]', formData.floor_number)
                submitData.append('detail_data[unit_number]', formData.unit_number)
                submitData.append('detail_data[bedrooms]', formData.bedrooms)
                submitData.append('detail_data[bathrooms]', formData.bathrooms)
                submitData.append('detail_data[ipl]', formData.ipl)
                break
            case 'boarding':
                submitData.append('detail_data[has_private_bathroom]', formData.has_private_bathroom)
                submitData.append('detail_data[max_occupants]', formData.max_occupants)
                submitData.append('detail_data[facilities]', formData.facilities)
                break
            case 'house':
                submitData.append('detail_data[bedrooms]', formData.bedrooms)
                submitData.append('detail_data[bathrooms]', formData.bathrooms)
                submitData.append('detail_data[floors]', formData.floors)
                submitData.append('detail_data[garage]', formData.garage)
                break
            case 'commercial':
                submitData.append('detail_data[bathrooms]', formData.bathrooms)
                submitData.append('detail_data[electricity_capacity]', formData.electricity_capacity)
                submitData.append('detail_data[parking_capacity]', formData.parking_capacity)
                break

            default:
                // Default behaviour untuk tipe baru atau fallback
                submitData.append('detail_data[notes]', formData.notes || '');
                submitData.append('detail_data[extra]', JSON.stringify(formData.extra || {}));
                console.warn('Unknown property type:', formData.property_type);
                break;
        }

        return submitData
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const submitFormData = createFormData();
            const response = await propertyApi.createProperty(submitFormData);

            console.log('Property created successfully:', response);

            message.success("Property created successfully! 🎉");

            // Reset semua field form
            setFormData({
                photos: [],
                name: "",
                province: "",
                city: "",
                full_address: "",
                surface_area: "",
                building_area: "",
                general_facilities: "",
                private_facilities: "",
                property_type: "apartement",
                rent_type: "",
                is_furnished: false,
                min_rent: "",
                rent_price: "",
                deposit: "",
                tower_name: "",
                floor_number: "",
                unit_number: "",
                bedrooms: "",
                bathrooms: "",
                ipl: "",
                has_private_bathroom: false,
                max_occupants: "",
                facilities: "",
                floors: "",
                garage: "",
                electricity_capacity: "",
                parking_capacity: "",
                notes: "",
                extra: {}
            });

        } catch (error) {
            console.error('Error creating property:', error);

            message.error("Error creating property! Please try again ⚠️");
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderDetailData = () => {
        switch (selectedType) {
            case 'apartement':
                return (
                    <>
                        <h6>Apartement Details</h6>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="tower_name" placeholder="Tower Name" value={formData.tower_name} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="floor_number" placeholder="Floor Number" value={formData.floor_number} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="unit_number" placeholder="Unit Number" value={formData.unit_number} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="bedrooms" placeholder="Bedrooms" value={formData.bedrooms} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="bathrooms" placeholder="Bathrooms" value={formData.bathrooms} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="ipl" placeholder="IPL (IDR)" value={formData.ipl} onChange={handleInputChange} />
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'boarding':
                return (
                    <>
                        <h6>Boarding Details</h6>
                        <div className="row">
                            <div className="col-md-6">
                                <label className="checkbox-item">Has Private Bathroom
                                    <input type="checkbox" name="has_private_bathroom" checked={formData.has_private_bathroom} onChange={handleInputChange} />
                                    <span className="checkmark" />
                                </label>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="max_occupants" placeholder="Max Occupants" value={formData.max_occupants} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="input-item input-item-textarea ">
                                    <textarea name="facilities" placeholder="Facilities (comma separated)" value={formData.facilities} onChange={handleInputChange} />
                                </div>
                            </div>
                        </div>
                    </>
                )
            case 'house':
                return (
                    <>
                        <h6>House Details</h6>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="bedrooms" placeholder="Bedrooms" value={formData.bedrooms} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="bathrooms" placeholder="Bathrooms" value={formData.bathrooms} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="floors" placeholder="Floors" value={formData.floors} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="checkbox-item">Has Garage
                                    <input type="checkbox" name="garage" checked={formData.garage} onChange={handleInputChange} />
                                    <span className="checkmark" />
                                </label>
                            </div>
                        </div>
                    </>
                )
            case 'commercial':
                return (
                    <>
                        <h6>Commercial Details</h6>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="bathrooms" placeholder="Bathrooms" value={formData.bathrooms} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="electricity_capacity" placeholder="Electricity Capacity (VA)" value={formData.electricity_capacity} onChange={handleInputChange} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="input-item input-item-textarea ">
                                    <input type="text" name="parking_capacity" placeholder="Parking Capacity" value={formData.parking_capacity} onChange={handleInputChange} />
                                </div>
                            </div>
                        </div>
                    </>
                )
            default:
                return null
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="ltn__myaccount-tab-content-inner">
                {/* Property Type Tabs */}
                <h6>Property Type</h6>
                <div className="row">
                    <div className="col-md-12">
                        <div style={styles.tabs}>
                            <ul style={styles.tabList} role="tablist">
                                {propertyTypes.map(type => (
                                    <li style={styles.tabItem} key={type}>
                                        <button
                                            style={{
                                                ...styles.tabButton,
                                                ...(selectedType === type ? styles.activeTab : {})
                                            }}
                                            onClick={() => handleTypeChange(type)}
                                            type="button"
                                        >
                                            {type.charAt(0).toUpperCase() + type.slice(1)}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>


                {/* Common Property Data */}
                <h6>Property Information</h6>
                <div className="row">
                    <div className="col-md-12">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="name" placeholder="*Property Name (mandatory)" value={formData.name} onChange={handleInputChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="province" placeholder="*Province" value={formData.province} onChange={handleInputChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="city" placeholder="*City" value={formData.city} onChange={handleInputChange} required />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="full_address" placeholder="*Full Address" value={formData.full_address} onChange={handleInputChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="surface_area" placeholder="Surface Area (m²)" value={formData.surface_area} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="building_area" placeholder="Building Area (m²)" value={formData.building_area} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="general_facilities" placeholder="General Facilities" value={formData.general_facilities} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="private_facilities" placeholder="Private Facilities" value={formData.private_facilities} onChange={handleInputChange} />
                        </div>
                    </div>
                    <h6>Property Photo</h6>

                    <div className="col-md-12">
                        <div className="input-item">

                            {/* Hidden file input -> tetap pakai handleInputChange */}
                            <input
                                type="file"
                                name="photos"
                                accept="image/*"
                                multiple
                                onChange={handleInputChange}
                                style={{ display: "none" }}
                                id="photo-hidden-input"
                            />

                            {/* Ant Design Upload UI */}
                            <Upload
                                listType="picture-card"
                                multiple
                                showUploadList={false}
                                fileList={uploadList.map(f => ({
                                    uid: f.uid || f.name + Math.random(),
                                    name: f.name,
                                    status: 'done',
                                    originFileObj: f,
                                    url: URL.createObjectURL(f),
                                }))}
                                beforeUpload={() => false}
                                onChange={({ fileList }) => {
                                    const newList = fileList.map(f => f.originFileObj).filter(Boolean);

                                    // cari file baru
                                    const newFiles = newList.filter(f => !uploadList.includes(f));

                                    // update uploadList
                                    setUploadList(newList);

                                    // kirim hanya file baru
                                    if (newFiles.length > 0) {
                                        const fakeEvent = {
                                            target: {
                                                name: "photos",
                                                type: "file",
                                                files: newFiles,
                                            },
                                        };
                                        handleInputChange(fakeEvent);
                                    }
                                }}
                            >
                                <div>
                                    <PlusOutlined />
                                    <div style={{ marginTop: 8 }}>Upload</div>
                                </div>
                            </Upload>

                            {/* PREVIEW + DELETE BUTTON */}
                            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                                {formData.photos?.map((file, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            position: "relative",
                                            width: 80,
                                            height: 80,
                                            borderRadius: 8,
                                            overflow: "hidden",
                                        }}
                                    >
                                        <Image
                                            src={URL.createObjectURL(file)}
                                            width={80}
                                            height={80}
                                            style={{ objectFit: "cover" }}
                                            preview={false}
                                        />

                                        {/* Tombol Delete */}
                                        <div
                                            onClick={() => handleRemovePhoto(file)}
                                            style={{
                                                position: "absolute",
                                                top: 2,
                                                right: 2,
                                                background: "rgba(0,0,0,0.6)",
                                                color: "white",
                                                width: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                cursor: "pointer",
                                                fontSize: 12,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            ✕
                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>

                {/* Property Settings */}
                <h6>Property Settings</h6>
                <div className="row">
                    <div className="col-md-4">
                        <div className="input-item">
                            <select name="property_type" className="nice-select" value={selectedType} onChange={(e) => handleTypeChange(e.target.value)}>
                                {propertyTypes.map(type => (
                                    <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="input-item">
                            <select name="rent_type" className="nice-select" value={formData.rent_type} onChange={handleInputChange}>
                                {rentTypes.map(type => (
                                    <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="input-item">
                            <select name="is_furnished" className="nice-select" value={formData.is_furnished} onChange={handleInputChange}>
                                {furnishedTypes.map(type => (
                                    <option key={type} value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Pricing */}
                <h6>Pricing Information</h6>
                <div className="row">
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="min_rent" placeholder="Minimum Rent Period (months)" value={formData.min_rent} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="rent_price" placeholder="Rent Price (IDR)" value={formData.rent_price} onChange={handleInputChange} required />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="input-item input-item-textarea ">
                            <input type="text" name="deposit" placeholder="Deposit (IDR)" value={formData.deposit} onChange={handleInputChange} required />
                        </div>
                    </div>
                </div>

                {/* Dynamic Detail Data based on property type */}
                {renderDetailData()}
                {/* Submit Button */}
                <div className="alert alert-warning d-none" role="alert">
                    Please note that the date and time you requested may not be available. We will contact you to confirm your actual appointment details.
                </div>
                <div className="btn-wrapper text-center--- mt-30">
                    <button className="btn theme-btn-1 btn-effect-1 text-uppercase" type="submit" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Submit Property'}
                    </button>
                </div>
            </div>
        </form>
    )
}

export default AddProperty